import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { User } from "../types/firebase";

// La configuración de Firebase debe ser reemplazada con tus credenciales
// Puedes obtenerlas desde la consola de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDzqfYq9BPQuB-65ChjXxd0E504je4wb7I",
  authDomain: "docuboe-e80c1.firebaseapp.com",
  projectId: "docuboe-e80c1",
  storageBucket: "docuboe-e80c1.firebasestorage.app",
  messagingSenderId: "737259300363",
  appId: "1:737259300363:web:abe4c3000210b98b88890e",
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export {
  auth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
};
export type { User };
